import * as React from "react";
import { useRouter } from "next/router";
import { Hooks, Context } from "@grandvisionhq/carts-v2";
import { useCartStorage } from "@grandvisionhq/lib-utils-cart";
import { getDisplayName } from "@grandvisionhq/utils";
function withCartFactory(settings) {
  return ({ isReadOnly = false, shouldShowQuoteLink = false } = {}) => (PageComponent) => {
    const displayName = getDisplayName(PageComponent);
    const WithCartFactory = (pageProps) => {
      const productLinkFormatter = Hooks.useGetProductLinkFormatter();
      const { query, push } = useRouter();
      const { cartHash: cartHashFromUrl, cartId: cartIdFromUrl } = query;
      const [cart, { setData, reset }] = useCartStorage();
      const cartIdRef = cartIdFromUrl || cart.cartId;
      const cartHashRef = cartHashFromUrl || cart.cartHash;
      const cartCount = cart?.cartCount || 0;
      const handleOnCartDataLoadedSuccessfully = React.useCallback(() => {
        setData({ cartId: cartIdRef, cartHash: cartHashRef, cartCount });
      }, [cartCount, cartHashRef, cartIdRef, setData]);
      const handleUnRecoverableErrors = React.useCallback(() => {
        settings.onUnRecoverableError({ resetCallback: reset, navigateTo: push });
      }, [push, reset]);
      const handleFinalizedCartError = React.useCallback(() => {
        settings.onFinalizedCartError?.({ resetCallback: reset, navigateTo: push });
      }, [push, reset]);
      return /* @__PURE__ */ React.createElement(
        Context.CartSettingsProvider,
        {
          settings: {
            ...settings,
            productLinkFormatter,
            isReadOnly,
            shouldShowQuoteLink,
            ...cartHashRef ? { cartHash: cartHashRef } : void 0,
            ...cartIdRef ? { cartId: cartIdRef } : void 0
          }
        },
        /* @__PURE__ */ React.createElement(
          Context.CartProvider,
          {
            cartId: cartIdRef,
            cartHash: cartHashRef,
            cartCount,
            onUpdateCartLocaleState: setData,
            onUnrecoverableErrors: handleUnRecoverableErrors,
            onFinalisedCartError: handleFinalizedCartError,
            onCartDataLoadedSuccessfully: handleOnCartDataLoadedSuccessfully
          },
          ({ cart: cart2, refetch }) => /* @__PURE__ */ React.createElement(PageComponent, { ...pageProps, cart: cart2, refetchCart: refetch })
        )
      );
    };
    WithCartFactory.getInitialProps = PageComponent.getInitialProps;
    WithCartFactory.displayName = `WithCartFactory(${displayName})`;
    return WithCartFactory;
  };
}
export {
  withCartFactory
};
//# sourceMappingURL=hoc.js.map
